import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-558a71fc")

_pushScopeId("data-v-558a71fc")
const _hoisted_1 = {
  class: "nav nav-pills justify-content-center",
  id: "myTab",
  role: "tablist"
}
const _hoisted_2 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_3 = {
  class: "nav-item",
  role: "presentation"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("ul", _hoisted_1, [
    _createVNode("li", _hoisted_2, [
      _createVNode("button", {
        class: "nav-link active",
        id: "dg-tab",
        "data-bs-toggle": "tab",
        "data-bs-target": '#' + _ctx.componenteIdPadre + 'datosGeneralesTab',
        type: "button",
        role: "tab",
        "aria-controls": "datosGenerales",
        "aria-selected": "true"
      }, " Datos generales ", 8, ["data-bs-target"])
    ]),
    _createVNode("li", _hoisted_3, [
      _createVNode("button", {
        class: "nav-link",
        id: "cc-tab",
        "data-bs-toggle": "tab",
        "data-bs-target": '#' + _ctx.componenteIdPadre + 'centroCosto',
        type: "button",
        role: "tab",
        "aria-controls": "centroCosto",
        "aria-selected": "false"
      }, " Centro de Costo ", 8, ["data-bs-target"])
    ])
  ]))
})